import {handleResponse, authHeader} from '../helpers';
const BASE_URL = process.env.REACT_APP_API_URL;
export const mapService = {
    saveRegion,
    getAllRegions,
    deleteRegion,
    getLeadMarkers,
    getCompareLeadMarkers,
}

function saveRegion(feature) {
    if (!feature.properties.name || feature.properties.name.length === 0) {
        return new Promise((resolve, reject) => {
            resolve({})
        });
    }
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(feature)
    };

    return fetch(BASE_URL + `/regions/save/`+feature.properties.name, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function deleteRegion(feature) {
    feature["ISDELETED"] = true;
    return this.saveRegion(feature)
}

function getAllRegions() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/regions/all`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getLeadMarkers(startDate, endDate) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/leads/`+startDate+'/'+endDate, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getCompareLeadMarkers() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}/leads/compare-market`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}